import createModel from "../createModel";
import { Incident } from "./Incident";

export const IncidentEvents = createModel("IncidentEvents", (json) => ({
    incidents: Incident.fromServerList(json.incidents),
    lifeClaimsDetailLink: json.lifeClaimsDetailLink,
    nonLifeClaimsDetailLink: json.nonLifeClaimsDetailLink,
}));
